export interface BaseShiftState {
  shiftName: string;
  shiftDateStart: string;
  shiftDateEnd: string;
  timeStart: string;
  timeEnd: string;
  location: string;
  requiredMentors: number;

  updateShiftName: (name: string) => void;
  updateShiftDateStart: (date: string) => void;
  updateShiftDateEnd: (date: string) => void;
  updateTimeStart: (time: string) => void;
  updateTimeEnd: (time: string) => void;
  updateLocation: (location: string) => void;
  updateRequiredMentors: (mentors: number) => void;
}

export const convertDayToDate = (date: string) => {
  return date === "Friday"
    ? "2026-09-18"
    : date === "Saturday"
    ? "2026-09-19"
    : "2026-09-20";
};
